import AttributeCell from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTable/cellCallbacks/AttributeCell';
import Region from '@/creditflowresearch/domain/Region';
import { IMarketStatView } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketStat';

interface IEmRegionCellProps {
  row: IMarketStatView,
  countItemVisible?: number,
}

const EmRegionCell = ({ row, countItemVisible = 2 }: IEmRegionCellProps) => {
  const emDisplayNames = row.regionIds
    .map((regionId) => Region.from(regionId)?.getEmDisplayName())
    .filter((emDisplayName): emDisplayName is string => Boolean(emDisplayName))
    .sort();

  return <AttributeCell cellData={ emDisplayNames } countItemVisible={ countItemVisible } />;
};

export default EmRegionCell;
